var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mode === 'guest')?_c('guest-home'):(_vm.mode === 'host')?_c('host-home'):(_vm.mode === 'admin')?_c('dashboard-home'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }